import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Upgrade http:// thumbnail URLs to https:// to avoid mixed-content errors.
 *  Legacy DB records from older enrichment providers (e.g. Google Books) may
 *  have been stored with http scheme. */
export function toHttps(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  return url.startsWith('http://') ? url.replace('http://', 'https://') : url;
}
